export default {"src":"/_next/static/media/whatsapp.a596380e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};